import { SVGComponentProps } from "./utils/Types"

const CreateConnectionsIcon = ({ width = 32, height = 32, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            height={height}
            width={width}
            version="1.1"
            viewBox="0 0 318.868 318.868"
        >
            <g>
                <path fill="currentColor" d="M77.449,150.493l19.975,6.49c-1.069,4.615-1.634,9.424-1.634,14.359c0,19.156,8.507,36.363,21.94,48.041l-12.366,17.021
		c-5.899-3.182-12.456-4.852-19.243-4.852c-13.016,0-25.349,6.279-32.993,16.799c-13.199,18.172-9.155,43.701,9.016,56.908
		c7.006,5.09,15.274,7.781,23.911,7.781c13.018,0,25.351-6.281,32.991-16.801c6.398-8.803,8.984-19.568,7.281-30.318
		c-1.411-8.912-5.639-16.92-12.061-23.047l12.359-17.012c9.587,5.791,20.815,9.127,32.81,9.127c11.992,0,23.219-3.336,32.806-9.127
		l12.362,17.016c-14.486,13.865-16.889,36.705-4.787,53.367c7.641,10.516,19.971,16.793,32.986,16.793
		c8.641,0,16.914-2.693,23.924-7.785c8.805-6.396,14.59-15.838,16.291-26.586c1.702-10.748-0.885-21.516-7.281-30.314
		c-7.639-10.519-19.973-16.801-32.99-16.801c-6.788,0-13.346,1.668-19.244,4.85l-12.365-17.018
		c13.434-11.68,21.941-28.887,21.941-48.043c0-4.936-0.565-9.744-1.635-14.359l19.976-6.49c6.716,13.977,20.84,23.045,36.676,23.045
		c4.271,0,8.513-0.676,12.603-2.006c10.35-3.359,18.77-10.551,23.711-20.25c4.94-9.695,5.808-20.734,2.445-31.086
		c-5.476-16.84-21.045-28.156-38.74-28.156c-4.267,0-8.504,0.674-12.596,2.002c-10.35,3.363-18.77,10.555-23.711,20.25
		c-4.097,8.041-5.383,17.006-3.788,25.732l-19.983,6.494c-9.01-21.184-29.186-36.514-53.098-38.57V86.924
		c19.871-2.695,35.24-19.762,35.24-40.359c0-22.463-18.277-40.738-40.742-40.738c-22.466,0-40.742,18.275-40.742,40.738
		c0,20.598,15.368,37.664,35.238,40.359v21.023c-23.912,2.057-44.088,17.387-53.099,38.57l-19.983-6.494
		c1.596-8.729,0.308-17.693-3.79-25.734c-4.941-9.693-13.361-16.885-23.709-20.246c-4.094-1.332-8.333-2.006-12.602-2.006
		c-17.693,0-33.26,11.316-38.734,28.16c-3.363,10.348-2.494,21.389,2.446,31.084c4.942,9.695,13.362,16.887,23.711,20.248
		c4.093,1.33,8.332,2.006,12.6,2.006C56.608,173.536,70.732,164.467,77.449,150.493z M115.457,267.645
		c1.243,7.844-0.645,15.701-5.315,22.127c-5.577,7.678-14.581,12.264-24.087,12.264c-6.297,0-12.329-1.965-17.441-5.678
		c-13.263-9.641-16.214-28.273-6.581-41.537c5.58-7.678,14.585-12.262,24.089-12.262c6.283,0,12.302,1.957,17.408,5.654
		c0.013,0.01,0.023,0.02,0.035,0.029c0.014,0.008,0.026,0.016,0.04,0.025C110.008,252.938,114.218,259.817,115.457,267.645z
		 M256.832,254.823c4.67,6.424,6.557,14.281,5.316,22.125c-1.242,7.844-5.465,14.734-11.891,19.402
		c-5.118,3.719-11.154,5.684-17.455,5.684c-9.504,0-18.506-4.582-24.082-12.256c-9.623-13.25-6.686-31.861,6.541-41.51
		c0.012-0.01,0.025-0.016,0.039-0.025c0.012-0.01,0.023-0.02,0.035-0.029c5.107-3.699,11.125-5.654,17.41-5.654
		C242.252,242.559,251.256,247.143,256.832,254.823z M251.613,119.289c3.605-7.078,9.75-12.326,17.303-14.779
		c2.992-0.971,6.086-1.465,9.197-1.465c12.914,0,24.277,8.26,28.273,20.553c2.453,7.555,1.82,15.611-1.785,22.689
		c-3.605,7.076-9.75,12.324-17.307,14.775c-2.992,0.975-6.088,1.469-9.2,1.469c-12.913,0-24.27-8.262-28.265-20.559h-0.001
		c0,0-0.001,0-0.001-0.002C247.375,134.42,248.008,126.364,251.613,119.289z M111.351,149.936
		c7.506-16.787,23.551-28.951,42.581-30.936c1.81-0.189,3.645-0.287,5.504-0.287c1.857,0,3.693,0.098,5.502,0.287
		c19.029,1.984,35.074,14.15,42.58,30.936c1.484,3.322,2.635,6.824,3.407,10.465c0.749,3.531,1.148,7.189,1.148,10.941
		c0,15.502-6.736,29.457-17.432,39.1c-2.723,2.455-5.703,4.631-8.895,6.482c-7.746,4.488-16.733,7.061-26.31,7.061
		c-9.579,0-18.567-2.572-26.314-7.063c-3.191-1.85-6.172-4.025-8.895-6.48c-10.695-9.643-17.431-23.598-17.431-39.1
		c0-3.752,0.398-7.41,1.148-10.941C108.716,156.76,109.866,153.256,111.351,149.936z M129.699,46.565
		c0-16.395,13.339-29.732,29.736-29.732c16.396,0,29.736,13.338,29.736,29.732c0,16.396-13.34,29.736-29.736,29.736
		C143.038,76.301,129.699,62.961,129.699,46.565z M40.772,162.53c-3.11,0-6.205-0.494-9.198-1.467
		c-7.554-2.453-13.699-7.701-17.306-14.779c-3.607-7.076-4.241-15.133-1.786-22.685c3.996-12.295,15.356-20.555,28.267-20.555
		c3.111,0,6.206,0.492,9.199,1.467c7.554,2.453,13.699,7.701,17.306,14.777c3.606,7.076,4.24,15.133,1.784,22.686
		C65.045,154.268,53.686,162.53,40.772,162.53z"/>
            </g>
        </svg>
    )
}

export default CreateConnectionsIcon
